import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { readReferralCode } from './utils/memberSession'
import { captureAttributionTouch } from './utils/attribution'

// Capture referral attribution before the first route renders. The landing URL
// may lose its query string when the visitor later opens login or registration.
readReferralCode()
void captureAttributionTouch().catch(() => {
  // The saved touch is retried on the visitor's next page load.
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
